import { accessRole } from "../../../../../helpers/access_role"
import { config } from "../../../../../helpers/config_global"
import React, { useState, Component, Fragment } from "react"
import { Redirect } from "react-router-dom"

import { Tooltip } from "reactstrap"

import MKIDatatable from '../../../../../modules/mki-datatable/lib'
import { ConfirmAlert } from '../../../../../helpers/ui/alert'

import { cancelToken } from "../../../../../services/adapters/kepegawaian/homeService"

import DataTableBloc from '../Blocs/DataTableBloc'
import IndexBloc from "../Blocs/IndexBloc"
import apiResponse from '../../../../../services/apiResponse'

import moment from "moment"

class TableInactiveComponent extends Component {
    dataTableBloc = new DataTableBloc();
    indexBloc = new IndexBloc();

    source
    historyTable = 'historySKPBawahanTableInctive'
    defaultOrder = 'employee_current_work_unit_hirarki'
    defaultSize = 10
    defaultSort = 'asc'
    configDatatable = {
        ...config('datatable'),
        sort: {
            column: this.defaultOrder,
            order: this.defaultSort
        }
    }
    
    constructor(props) {
        super(props)
        this.state = {
            tooltip: false,
            detailUuid: null,
            skpUUid: null,
            updateUuid: null,
            inactiveUuid: null,
            defaultSize: 10,
            rows: [],
            totalRow: 0,
            loadingTable: true,
            filter: sessionStorage.getItem(this.historyTable) ?
                JSON.parse(sessionStorage.getItem(this.historyTable)) :
                {
                    filter_value: "",
                    page_number: 1,
                    page_size: this.defaultSize,
                    sort_order: {
                        column: this.defaultOrder,
                        order: this.defaultSort
                    }
                }
        }
    }
    toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });

    userdata = JSON.parse(localStorage.getItem('userdata'));
    loadData = async () => {
        /* history Datatable */
        sessionStorage.setItem(this.historyTable, JSON.stringify(this.state.filter))

        let additionalFilter = this.props.additionalFilter;

        /* kirim ke server */
        let offset = (this.state.filter.page_number-1)*this.state.filter.page_size
        if(this.state.defaultSize!==this.state.filter.page_size) {
            this.setState({
                defaultSize: this.state.filter.page_size
            })
            offset = 0
            this.configDatatable.page_number = 1
        }
        const query = {
            search: this.state.filter.filter_value,
            limit: this.state.filter.page_size,
            offset: offset,
            order: this.state.filter.sort_order.column,
            sort: this.state.filter.sort_order.order,
            status: 1,
            euuid:this.userdata.employee_uuid,
            work_unit:this.userdata.employee_current_work_unit_uuid,
            ...additionalFilter
        }
        await this.dataTableBloc.fetchRowTableInactive(query, this.source.token)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadData()
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                //this.inactiveData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }
    
    inactiveData = async () => {
        //await this.dataTableBloc.fetchInactive({ uuid: this.state.inactiveUuid })
    }

    handleDownloadDRH = (uuid) => {
        this.indexBloc.fetchDownloadDRH({
            uuid: uuid
        });
    }
    
    componentDidMount() {
        console.log('his.userdata')
        console.log(this.userdata)
        this.setTokenAPI()

        this.dataTableBloc.rowtableChannelInactive.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({
                        loadingTable: false
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        loadingTable: true
                    })
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    this.setState({
                        totalRow: response.total,
                        rows: response.result,
                        loadingTable: false
                    })
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
    }

    componentWillUnmount() {
        this.dataTableBloc.rowtableChannelInactive.unsubscribe()
    }

    columns = [
        {
            key: "employee_nip",
            text: "NIP",
            className: "employee_nip",
            sortable: true,
            width: '80'
        },
        {
            key: "employee_full_name",
            text: "Nama",
            className: "employee_full_name",
            sortable: true,
            width: '20%'
        },
        {
            key: "employee_current_position_name",
            text: "Jabatan",
            className: "employee_current_position_name",
            sortable: true,
        },
        {
            key: "employee_current_work_unit_name",
            text: "Unit Kerja",
            className: "employee_current_work_unit_name",
            sortable: true,
            // width: '20%'
        },
        // {
        //     key: "action",
        //     text: "Action",
        //     className: "action",
        //     width: 120,
        //     sortable: false,
        //     align: 'center',
        //     cell: record => {
        //         const thisId = record.employee_id
        //         return (
        //             <Fragment>
        //                 <span>
        //                     <button
        //                         className="btn btn-warning btn-sm"
        //                         id={"detail-" + thisId}
        //                         onClick={() => {
        //                             this.setState({
        //                                 detailUuid: record.employee_uuid
        //                             })
        //                         }}
        //                         style={{
        //                             marginRight: '2px',
        //                             padding: '2px 5px'
        //                         }}>
        //                             <i className="uil-file-search-alt"></i>
        //                     </button>
        //                     <Tooltip
        //                         style={{
        //                             marginBottom: 2
        //                         }}
        //                         placement="top" isOpen={this.state["detail" + thisId]} target={"detail-" + thisId}
        //                         toggle={() => {
        //                             this.setState({
        //                                 ["detail" + thisId] : !this.state["detail" + thisId]
        //                             })
        //                         }}
        //                     >Data SKP</Tooltip>
        //                 </span>
                        
        //             </Fragment>
        //         );
        //     }
        // }
    ]

    render() {
        return (
            <>
                <MKIDatatable
                    className={this.configDatatable.tableClass}
                    config={this.configDatatable}
                    records={this.state.rows}
                    columns={this.columns}
                    dynamic={true}
                    minWidth={1000}
                    total_record={this.state.totalRow}
                    initial={this.state.filter}
                    onChange={(filter) => {
                        this.setState({
                            loadingTable: true,
                            filter: filter
                        }, function () {
                            this.setTokenAPI()
                        });
                    }}
                    loading={this.state.loadingTable}
                />
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menghapus data ini?"

                    loadingTitle="Memproses data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil dihapus"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal dihapus"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.detailUuid !== null ?
                    // <Redirect to={"/sample.html?detail&uuid=" + this.state.detailUuid}/>
                    <Redirect to={"/kepegawaian/skp.html?period_bawahan&euuid=" + this.state.detailUuid}/>
                : null }
                 {/* { this.state.skpUUid !== null ?
                    // <Redirect to={"/sample.html?detail&uuid=" + this.state.detailUuid}/>
                    <Redirect to={"/kepegawaian/skp.html?simantab&uuid=" + this.state.skpUUid}/>
                : null } */}
            </>
        )
    }

}

export default TableInactiveComponent